export default {
    global:{
        yes:'Yes',
        no:'No',
        cancel:'Cancel',
        confirm:'Confirm',
        saveAs:'Save As',
        close:'Close',
        operation:'operation',
        unknownError:'unknown error'
    }
}
